export default "../../../static/plugins/visualizations/nora/static/assets/fontawesome-webfont.a35720c2fed2c7f043bc7e4ffb45e073.woff";